import type { LangCode, NormalChatMessageType } from '@module/types/centrifuge/public-message/normalChatMessageTypes';

/**
 * 채팅 사용자 타입 플래그 반환
 */
export function getChatUserFlags(type: NormalChatMessageType) {
  return {
    userIsSupport: type === 'support',
    userIsManager: type === 'manager',
    userIsRoomMaster: type === 'bj',
  };
}

interface TranslateFlagsParams {
  userType: NormalChatMessageType;
  lang?: LangCode[];
  hasNickname: boolean;
  hasMessage: boolean;
  viewerIsRoomMaster: boolean;
}

/**
 * 번역 버튼 활성화 플래그 반환
 * - isNickTranslateEnabled: 일본유저이고 현재 룸마스터일 때 닉네임 번역버튼 활성화
 * - isMessageTranslateEnabled: (일본유저 or 서포터일때) 메시지 번역버튼 활성화
 */
export function getTranslateFlags(params: TranslateFlagsParams) {
  const { userType, lang, hasNickname, hasMessage, viewerIsRoomMaster } = params;
  const { userIsSupport, userIsManager, userIsRoomMaster } = getChatUserFlags(userType);
  const isJapaneseViewer = lang?.includes('ja' as LangCode) ?? false;

  return {
    isJapaneseViewer,
    isNickTranslateEnabled:
      isJapaneseViewer && hasNickname && !userIsSupport && !userIsManager && !userIsRoomMaster && viewerIsRoomMaster,
    isMessageTranslateEnabled: hasMessage && (isJapaneseViewer || userIsSupport) && !userIsManager && !userIsRoomMaster,
  };
}
